import { crudActionConstantsGenerator } from './crud_action_constants_generator';
import { crudActionCreatorsGenerator } from './crud_action_creators_generator';

export const USER_GROUPS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('USER_GROUPS');
export const USER_GROUPS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	USER_GROUPS_CRUD_ACTION_CONSTANTS
);
